import TermDrawer from "../TermDrawer";
import "./TagsDrawer.scss";

const AddTagsDrawer = () => <TermDrawer type="create-tag" />;

export default AddTagsDrawer;
